import * as React from "react";
import { authorize } from "@athena-portal/components";
import { PluginTemplates } from "../../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../../components/navigation/FalconHeader";
import { Checkbox } from "../../../../../../components/inputs/Checkbox";
import {FalconNavigatorHeader} from "@falcon/services";

interface IProps {
    match?: any
}

interface IState {
    addCardSuccess: boolean
    addCardCancelled: boolean
    continuousPaymentsAllowedValidationError: boolean
    continuousPaymentsAllowed: boolean
    adHocPaymentsAllowed: boolean
}

@authorize
export class CardConsentPage extends React.Component<IProps, IState> {
    private pluginTemplates = new PluginTemplates();

    constructor(props: IProps) {
        super(props);

        this.state = {
            addCardSuccess: false,
            addCardCancelled: false,
            continuousPaymentsAllowedValidationError: false,
            continuousPaymentsAllowed: sessionStorage.getItem("Falcon_ContinuousPaymentsAllowed") === 'true',
            adHocPaymentsAllowed: sessionStorage.getItem("Falcon_adHocPaymentsAllowed") === 'true'
        };

        this.onContinuousPaymentsAllowedChange = this.onContinuousPaymentsAllowedChange.bind(this);
        this.onAdHocPaymentsAllowedChange = this.onAdHocPaymentsAllowedChange.bind(this);
        this.onValidate = this.onValidate.bind(this);
        this.next = this.next.bind(this);
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Change your payment card");
    }

    public render() {

        return (
            <React.Fragment>
                <FalconHeader/>
                <div className="plugin">
                    <FalconNavigatorHeader
                        back="/dashboard/paymentHistory"
                        title="Change your payment card"
                    />
                    <div className="panel bg-white overflow-hidden p-0 mx-3 font-weight-extra-light">
                        <div className="inner-content pb-4">
                            <Checkbox
                                className="mt-3 ml-3"
                                label="I agree that my card will be charged on a monthly basis to cover the cost of my cover"
                                name="paymentInformationStorageCheckbox"
                                id="paymentInformationStorageCheckbox"
                                value={this.state.continuousPaymentsAllowed}
                                onChanged={this.onContinuousPaymentsAllowedChange}/>
                            {this.state.continuousPaymentsAllowedValidationError && (
                                <div className="invalid-feedback d-block" role="alert" style={{marginLeft: "20px"}}>
                                    Unfortunately, we cannot provide you with cover unless you consent to allow LV to charge your card on a monthly basis.
                                </div>
                            )}
                            <Checkbox
                                className="mt-3 ml-3"
                                label="I consent to my card details being stored securely for future transactions"
                                name="cardStorageConsentCheckbox"
                                id="cardStorageConsentCheckbox"
                                value={this.state.adHocPaymentsAllowed}
                                onChanged={this.onAdHocPaymentsAllowedChange}/>
                            <div style={{"marginBottom": "20px"}} />
                            <a href="javascript:void(0)" onClick={this.next} className="btn btn-white-dashboard m-auto" id="changeCard">
                                Change card
                            </a>
                        </div>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, "/dashboard/paymentHistory")}
                </div>
                <FalconFooter/>
            </React.Fragment>
        );
    }

    private onContinuousPaymentsAllowedChange(value: boolean){
        sessionStorage.setItem("Falcon_ContinuousPaymentsAllowed", value.toString())
        this.setState({
            continuousPaymentsAllowed: value,
            continuousPaymentsAllowedValidationError: !value
        })
    }

    private onAdHocPaymentsAllowedChange(value: boolean){
        sessionStorage.setItem("Falcon_adHocPaymentsAllowed", value.toString())
        this.setState({adHocPaymentsAllowed: value})
    }

    private onValidate(): boolean{
        if(!this.state.continuousPaymentsAllowed){
            this.setState({
                continuousPaymentsAllowedValidationError: true
            })
            return false;
        } else{
            this.setState({
                continuousPaymentsAllowedValidationError: false
            })
            return true;
        }
    }

    private next() {
        if (this.onValidate()) {
            window.location.assign("/dashboard/account/changeCard");
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/changeCard/subscription/CardConsentPage.tsx